import ProductItem from '../components/ProductItem';
import RTE from '../components/RTE';

export default class StaticSubcollection {
  constructor(section) {
    this.el = section.el;
    this.toggles = this.el.querySelectorAll('[data-menu-list-toggle]');
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    for (let i = 0; i < this.toggles.length; i++) {
      this.toggles[i].addEventListener('click', (event) => { this.toggle(event) });
    }
  }

  toggle(event) {
    const links = event.currentTarget.parentNode.querySelectorAll('[data-menu-list-hidden]');
    const text = event.currentTarget.querySelectorAll('.menu-list-link-text');

    for (let i = 0; i < text.length; i++) {
      text[i].classList.toggle('menu-list-link-hidden');
    }

    for (let i = 0; i < links.length; i++) {
      links[i].classList.toggle('menu-list-link-hidden');
    }
  }

  onSectionUnload() {
    this.products.forEach(product => product.unload());
    this.rtes.forEach(rte => rte.unload());

    for (let i = 0; i < this.toggles.length; i++) {
      this.toggles[i].removeEventListener('click', (event) => { this.toggle(event) });
    }
  }
}
